import { Component, OnInit } from '@angular/core';
import { CommonMethods } from './common-methods';
import { UiService } from './ui.service';
import { LoaderServiceService } from './loader-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  loginStatus: boolean = false;
  loading$ = this.loaderService.loading$; 
  constructor(private uiService: UiService,
    private loaderService: LoaderServiceService) { }

  ngOnInit() {
    let auth = CommonMethods.getItem("auth");
    if (auth) {
      this.loginStatus = true;
    } else {
      this.loginStatus = false;
    }

    this.uiService.loginValid.subscribe((value) => {
      if (value != null) {
        this.loginStatus = value;
      }

    })

  }

  /**
   * To close the sidebar if user clicks on body for tab/mobile
   */
  closeSidebar(event: MouseEvent) {
    const sidebar = document.getElementById('sidebar');
    if (!sidebar?.contains(event.target as Node) && window.innerWidth <= 991) {
      sidebar?.classList.remove('active');
    }
  }
}
